import React, { Component } from 'react'
import Reservatorio from './reservatorio'
import './index.css'

const STATUS_DEFAULTS = {
    normal: { text: 'Normal', color: '#1bc57ef5' },
    alerta: { text: 'Alerta', color: '#ffb100f5' },
    perigo: { text: 'Perigoso', color: 'tomato' },
}

const SCALE_PERCENTS = [100, 80, 60, 40, 20]

const resolveStatusLabel = (params, key) => {
    const custom = params?.[`label_${key}`]
    if (typeof custom === 'string' && custom.trim()) return custom.trim()
    return STATUS_DEFAULTS[key].text
}

const inRange = (percent, faixa) => {
    const min = parseFloat(faixa?.min)
    const max = parseFloat(faixa?.max)
    if (Number.isNaN(min) || Number.isNaN(max)) return false
    return percent >= min && percent < max
}

const formatScaleValue = (alturaReservatorio, percent) => {
    const raw = (Number(alturaReservatorio) * percent) / 100
    if (!Number.isFinite(raw)) return '—'
    return raw.toFixed(2)
}

class ReservatorioV2 extends Component {
    lastSignature = null

    state = {
        data: { percent: 0, value: null, status: { text: '', color: '' } }
    }

    componentDidMount = () => {
        if (this.props.dataWidget) {
            this.calcValues(this.props.dataWidget)
        }
    }

    componentWillReceiveProps = (nextProps) => {
        if (this.shouldRecalcValues(nextProps.dataWidget)) {
            this.calcValues(nextProps.dataWidget)
        }
    }

    getWidgetSignature = (dataWidget) => JSON.stringify({
        value: dataWidget?.value,
        altura: dataWidget?.params?.valor_altura,
        normal: dataWidget?.params?.valor_normal,
        alerta: dataWidget?.params?.valor_alerta,
        perigo: dataWidget?.params?.valor_perigo,
        label_normal: dataWidget?.params?.label_normal,
        label_alerta: dataWidget?.params?.label_alerta,
        label_perigo: dataWidget?.params?.label_perigo,
    })

    shouldRecalcValues = (dataWidget) => {
        if (!dataWidget) return false
        return this.getWidgetSignature(dataWidget) !== this.lastSignature
    }

    calcValues = (dataWidget) => {
        this.lastSignature = this.getWidgetSignature(dataWidget)
        const params = dataWidget?.params
        const alturaReservatorio = parseFloat(params?.valor_altura)
        const value = parseFloat(dataWidget.value) * 100
        const percent = Number.isFinite(alturaReservatorio) && alturaReservatorio !== 0
            ? Math.round(value / alturaReservatorio)
            : 0

        let status = { text: '', color: '' }

        if (inRange(percent, params?.valor_normal)) {
            status = { text: resolveStatusLabel(params, 'normal'), color: STATUS_DEFAULTS.normal.color }
        } else if (inRange(percent, params?.valor_alerta)) {
            status = { text: resolveStatusLabel(params, 'alerta'), color: STATUS_DEFAULTS.alerta.color }
        } else if (inRange(percent, params?.valor_perigo)) {
            status = { text: resolveStatusLabel(params, 'perigo'), color: STATUS_DEFAULTS.perigo.color }
        }

        this.setState({ data: { percent, value: dataWidget.value, status } })
    }

    renderScale = (alturaReservatorio) => (
        SCALE_PERCENTS.map((percent) => {
            const value = formatScaleValue(alturaReservatorio, percent)

            return (
                <div key={percent} className="reservatorio-v2-scale-item" title={`${value}m (${percent}%)`}>
                    <span className="reservatorio-v2-scale-value">{value}m</span>
                    <span className="reservatorio-v2-scale-pct">({percent}%)</span>
                </div>
            )
        })
    )

    render() {
        const { data } = this.state
        const { params } = this.props.dataWidget
        const fillOffset = Number.isFinite(data.percent) ? parseInt((100 - data.percent) + 5, 10) : 105

        return (
            <div className="hdv-bloco-informacao hdv-chart-bloco-reactgridlayout reservatorio-v2">
                {this.props.dataWidget?.ultimoEvento({ showUnity: false })}
                <div className="reservatorio-v2-body">
                    <div className="reservatorio-v2-visual">
                        <div className="reservatorio-v2-tank-inner">
                            <div className="reservatorio-v2-tank-frame">
                                <Reservatorio percent={fillOffset} />
                                <div className="reservatorio-v2-overlay">
                                    <div className="reservatorio-v2-values">
                                        <span className="reservatorio-v2-percent">{data.percent}%</span>
                                        {data.value == null || data.value === ''
                                            ? null
                                            : <span className="reservatorio-v2-meters">{data.value}m</span>}
                                    </div>
                                    {data.status.text
                                        ? (
                                            <div
                                                className="reservatorio-v2-badge"
                                                style={{ backgroundColor: data.status.color }}
                                                title={data.status.text}
                                            >
                                                <span>{data.status.text}</span>
                                            </div>
                                        )
                                        : null}
                                </div>
                            </div>
                        </div>
                        <div className="reservatorio-v2-scale">
                            <div className="reservatorio-v2-scale-ruler" aria-hidden="true" />
                            <div className="reservatorio-v2-scale-labels">
                                {this.renderScale(parseFloat(params?.valor_altura))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ReservatorioV2
